<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>

    <Multiselect
      v-model="inputValue"
      :options="options"
      :multiple="true"
      :disabled="disabled"
      :group-label="optionLabel"
      :group-values="optionValue"
      :group-select="true"
      :placeholder="placeholder"
      :track-by="optionSelected"
      :label="optionSelected"
      :closeOnSelect="false"
      @select="onSelect($event)"
      @remove="onRemove($event)"
    >
      <span
        class="checkbox-label"
        slot="option"
        slot-scope="scope"
        @click.self="select(scope.option)"
        v-if="scope.option.name"
      >
        <span class="custom-control custom-checkbox d-inline-block">
          <input
            type="checkbox"
            v-model="scope.option.checked"
            @focus.prevent
            class="custom-control-input"
          />
          <label class="custom-control-label" for="customCheckbox"></label>
        </span>

        {{ scope.option.name }}
      </span>
    </Multiselect>

    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  components: {
    Multiselect,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    //Dropdown label
    label: {
      type: String,
      default: "",
    },
    // Dropdown reactive value
    value: {
      type: [String, Object, Array],
      default: "",
    },

    // Dropdown placeholder
    placeholder: {
      type: String,
      default: "Please Select",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
    },

    // Dropdown disabled state
    disabled: {
      type: Boolean,
      default: false,
    },
    // Dropdown autofocus state
    autofocus: {
      type: Boolean,
      default: false,
    },
    //Dropdown options
    options: {
      type: Array,
      default: null,
    },

    //Dropdown option label
    optionLabel: {
      type: String,
      default: null,
    },
    //Dropdown option value
    optionValue: {
      type: String,
      default: null,
    },
    //Dropdown option diabled
    optionDisabled: {
      type: String,
      default: null,
    },
    //Dropdown show clear icon
    showClear: {
      type: Boolean,
      default: false,
    },
    //Dropdown show filter
    filter: {
      type: Boolean,
      default: false,
    },
    //Dropdown filter placeholder
    filterPlaceholder: {
      type: String,
      default: null,
    },
    //Dropdown display (chip or comma)
    display: {
      type: String,
      default: "comma",
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },

    // Multi select control

    labelShown: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    optionSelected: {
      type: String,
      default: null,
    },
  },
  methods: {
    onSelect(option) {
      this.$emit("inputselect", option);
    },
    onRemove(option) {
      this.$emit("inputremove", option);
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
